import { render, staticRenderFns } from "./jurisdiction.vue?vue&type=template&id=f0c53eb0&scoped=true&"
import script from "./jurisdiction.vue?vue&type=script&lang=js&"
export * from "./jurisdiction.vue?vue&type=script&lang=js&"
import style0 from "./jurisdiction.vue?vue&type=style&index=0&id=f0c53eb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c53eb0",
  null
  
)

export default component.exports